'use strict';

var _ = require('../dependency')._,
    config = require('../config'),
    $u = require('../utilities'),
    chartTypes = require('./chartTypes'),
    constants = require('../constants');

var GRAPHS = config.graphs,
    $d = config.druid;

var chartId = 'PLUGIN_USAGE_TREND',
    dataSeries = {
        TIMESTAMP: 'timestamp',
        PLUGIN_COUNT: 'pluginCount',
        CUSTOMER_WITH_WEBFORM: 'customersWithWebForm',
        CUSTOMER_WITH_GUESTBOOK: 'customersWithGuestBook',
        CUSTOMER_WITH_WECHAT: 'customersWithWeChat',
        CUSTOMER_WITH_FOURSQUARE: 'customersWithFoursquare',
        CUSTOMER_WITH_INSTAGRAM: 'customersWithInstagram',
        CUSTOMER_WITH_LINKEDIN: 'customersWithLinkedIn',
        CUSTOMER_WITH_RADIUS: 'customersWithRadius',
        CUSTOMER_WITH_FACEBOOK: 'customersWithFacebook',
        CUSTOMER_WITH_GOOGLE_PLUS: 'customersWithGooglePlus',
        CUSTOMER_WITH_TWITTER: 'customersWithTwitter',
        CUSTOMER_WITH_SMS: 'customersWithSMS',
        CUSTOMER_WITH_CLICKTHROUGH: 'customersWithClickthrough'
    },
    fieldNames = {
        CUSTOMER_WITH_WEBFORM: 'gmsPortalWebFormEnabledCount',
        CUSTOMER_WITH_GUESTBOOK: 'gmsPortalGuestBookEnabledCount',
        CUSTOMER_WITH_WECHAT: 'gmsPortalWeChatEnabledCount',
        CUSTOMER_WITH_FOURSQUARE: 'gmsPortalFoursquareEnabledCount',
        CUSTOMER_WITH_INSTAGRAM: 'gmsPortalInstagramEnabledCount',
        CUSTOMER_WITH_LINKEDIN: 'gmsPortalLinkedInEnabledCount',
        CUSTOMER_WITH_RADIUS: 'gmsPortalRADIUSEnabledCount',
        CUSTOMER_WITH_FACEBOOK: 'gmsPortalFacebookEnabledCount',
        CUSTOMER_WITH_GOOGLE_PLUS: 'gmsPortalGPlusEnabledCount',
        CUSTOMER_WITH_TWITTER: 'gmsPortalTwitterEnabledCount',
        CUSTOMER_WITH_SMS: 'gmsPortalSMSEnabledCount',
        CUSTOMER_WITH_CLICKTHROUGH: 'gmsPortalClickthroughEnabledCount'
    },
    /**
     * [dataConfig The query params to pass to the API http endpoint POST. Currently this are specific to druid querying.
     * can be modified for other data provider systems.]
     * @type {Object}
     */
    dataConfig = [{
        queryType: 'timeseries',
        /*!ToDo above use this from druid settings object (settings maybe in matrix charts)*/
        dataSource: 'babbage',
        /*above Can be set in library matrix charts*/
        aggregations: generatePluginAggregatorSumQuery(dataSeries, fieldNames)
    }];

module.exports = chartTypes.trendCharts.createConfig({
    chartId: chartId,
    dataSeries: dataSeries,
    fieldNames: fieldNames,
    dataConfig: dataConfig,
    chartTemplate: chartTemplate,
    averageTask: true,
    modifyResponse: responseModifierFn
});

function responseModifierFn(context, config, next) {
    var model = context.apiMergedResponse,
        computedModel = {},
        seriesSum = 0;

    _.forEach(_.values(dataSeries), function (seriesName) {
        seriesSum = _.reduce(model[seriesName], function (sum, n) {
            return sum + n;
        }, 0);

        if (seriesSum !== 0 || seriesName === dataSeries.TIMESTAMP) {
            computedModel[seriesName] = model[seriesName];
        }
    });

    context.chartData = computedModel;
    next();
}

function generatePluginAggregatorSumQuery(dataSeriesObj, fieldNamesObj) {
    var returnArray = [];

    _.forEach(_.keys(dataSeriesObj), function (pluginKey) {
        if (pluginKey !== 'TIMESTAMP' && pluginKey !== 'PLUGIN_COUNT') {
            returnArray.push({
                type: 'longSum',
                name: dataSeriesObj[pluginKey],
                fieldName: fieldNamesObj[pluginKey]
            });
        }
    });

    return returnArray;
}

function chartTemplate(data, width) {
    width = parseInt(width.match(/\d+/g)[0], 10);
    var duration = data.__duration,
        granularity = data.__granularity,
        xAxisLabelOffset = $u.charts.getXaxisOffset(duration),
        x = xAxisLabelOffset.x,
        y = xAxisLabelOffset.y,
        compressLegend = true,
        legendWidth = 510,
        legendAdjustments = $u.charts.getLegendAdjustments(duration, compressLegend, legendWidth),
        isServer = data._env === constants.SERVER;

    var yAxisBaseUnit = '',
        yAxisRoundOff = false,
        xAxisFormatter = $u.charts.generateXaxisDaysData,
        yAxisFormatter = $u.charts.chartYaxisFormatter,
        yAxisTrimDecimalPlaces = 2;

    var chartTemplateObj = {
        dataTableConfig: {
            duration: duration,
            granularity: granularity,
            xAxisFormatter: xAxisFormatter,
            yAxisFormatter: yAxisFormatter,
            yAxisBaseUnit: yAxisBaseUnit,
            yAxisRoundOff: yAxisRoundOff,
            xAxisDataHeader: 'Dates',
            removeHiddenSeries: true
        },
        chart: {
            zoomType: 'x,y',
            marginTop: GRAPHS.GLOBAL.CHART_MARGINS.TOP,
            marginBottom: GRAPHS.GLOBAL.CHART_MARGINS.BOTTOM,
            events: {
                load: function () {
                    var dataUnit,
                        chartContext = this,
                        dataArray;

                    _.forEach(chartContext.yAxis, function (yAxisObject) {
                        dataArray = [];
                        dataUnit = ' ';
                        _.forEach(yAxisObject.series, function (seriesItem) {
                            dataArray.push(seriesItem.dataMax);
                        });
                        dataUnit = $u.charts.getUnitsFromMax(_.max(dataArray), '').unit;
                        yAxisObject.setTitle({
                            text: data.i18n.YAXIS_TEXT + ' ' + dataUnit
                        });
                    });
                }
            }
        },
        title: {
            text: ''
        },
        credits: {
            enabled: false
        },
        tooltip: {
            formatter: function () {
                var currentContext = this;
                var tooltipUnitObj = yAxisFormatter(currentContext.y, currentContext.series.dataMax, yAxisBaseUnit, yAxisRoundOff, yAxisTrimDecimalPlaces);

                return $u.charts.sformat('{0}<br>{1}: {2} {3}',
                    xAxisFormatter(duration, granularity, currentContext.x),
                    currentContext.series.name,
                    tooltipUnitObj.value,
                    tooltipUnitObj.unit
                );
            },
            valueDecimals: 0
        },
        legend: {
            y: legendAdjustments.y,
            itemDistance: legendAdjustments.itemDistance,
            width: legendAdjustments.width
        },
        xAxis: {
            categories: data[dataSeries.TIMESTAMP],
            /*!ToDo this may be a setting for druid default time series name*/
            tickmarkPlacement: 'on',
            labels: {
                step: function () {
                    if (data.timestamp) {
                        return data.timestamp.length >=
                            GRAPHS.GLOBAL.MAX_XAXIS_LABELS ? 2 : 1;
                    }
                } (),
                rotation: -45,
                align: 'center',
                x: x,
                y: y,
                style: {
                    fontFamily: GRAPHS.GLOBAL.FONT_FAMILY,
                    fontSize: GRAPHS.GLOBAL.CHART_FONT_SIZE.AXIS_LABEL
                },
                formatter: function () {
                    return xAxisFormatter(duration, granularity, this.value);
                },
                useHTML: true,
                autoTransform: true
            }
        },
        yAxis: [{
            allowDecimals: false,
            title: {
                text: data.i18n.YAXIS_TEXT,
                style: {
                    fontSize: GRAPHS.GLOBAL.CHART_FONT_SIZE.AXIS_TITLE,
                    color: GRAPHS.GLOBAL.COLORS.MOJO_DARK_GREY
                }
            },
            labels: {
                format: '{value}',
                formatter: function () {
                    var that = this,
                        yAxisValue = that.value,
                        yMaxValue = that.axis.dataMax;

                    return yAxisFormatter(yAxisValue, yMaxValue,
                        yAxisBaseUnit, yAxisRoundOff).value;
                },
                style: {
                    fontFamily: GRAPHS.GLOBAL.FONT_FAMILY,
                    fontSize: GRAPHS.GLOBAL.CHART_FONT_SIZE.AXIS_LABEL
                },
                x: -20
            },
            min: 0,
            maxPadding: 0.1,
            lineColor: GRAPHS.GLOBAL.COLORS.MOJO_DARK_GREY,
            lineWidth: 1
        }],
        plotOptions: {
            line: {
                marker: {
                    enabled: true,
                    radius: width / 400 + 1
                }
            },
            series: {
                events: {
                    legendItemClick: function () {
                        var dataUnit,
                            legendContext = this,
                            legendIndex = legendContext.index,
                            dataArray = [];

                        _.forEach(legendContext.chart.legend.allItems, function (legendItem) {
                            if (legendItem.index === legendIndex) {
                                if (!legendItem.visible) {
                                    dataArray.push(legendItem.dataMax);
                                }
                            } else {
                                if (legendItem.visible) {
                                    dataArray.push(legendItem.dataMax);
                                }
                            }
                        });

                        dataUnit = $u.charts.getUnitsFromMax(_.max(dataArray), '').unit;

                        legendContext.yAxis.setTitle({
                            text: data.i18n.YAXIS_TEXT + ' ' + dataUnit
                        });
                    }
                }
            }
        },
        series: [{
            type: 'line',
            name: 'Facebook',
            data: data[dataSeries.CUSTOMER_WITH_FACEBOOK],
            color: GRAPHS.GLOBAL.COLORS.CHART_BROWN,
            showInLegend: data[dataSeries.CUSTOMER_WITH_FACEBOOK] ? true : false
        }, {
            type: 'line',
            name: 'Twitter',
            data: data[dataSeries.CUSTOMER_WITH_TWITTER],
            color: GRAPHS.GLOBAL.COLORS.MOJO_BLUE,
            showInLegend: data[dataSeries.CUSTOMER_WITH_TWITTER] ? true : false
        }, {
            type: 'line',
            name: 'LinkedIn',
            data: data[dataSeries.CUSTOMER_WITH_LINKEDIN],
            color: GRAPHS.GLOBAL.COLORS.RANGE10,
            showInLegend: data[dataSeries.CUSTOMER_WITH_LINKEDIN] ? true : false
        }, {
            type: 'line',
            name: 'Google Plus',
            data: data[dataSeries.CUSTOMER_WITH_GOOGLE_PLUS],
            color: GRAPHS.GLOBAL.COLORS.CHART_GREEN,
            showInLegend: data[dataSeries.CUSTOMER_WITH_GOOGLE_PLUS] ? true : false
        }, {
            type: 'line',
            name: 'Instagram',
            data: data[dataSeries.CUSTOMER_WITH_INSTAGRAM],
            color: GRAPHS.GLOBAL.COLORS.RANGE9,
            showInLegend: data[dataSeries.CUSTOMER_WITH_INSTAGRAM] ? true : false
        }, {
            type: 'line',
            name: 'Foursquare',
            data: data[dataSeries.CUSTOMER_WITH_FOURSQUARE],
            color: GRAPHS.GLOBAL.COLORS.RANGE8,
            showInLegend: data[dataSeries.CUSTOMER_WITH_FOURSQUARE] ? true : false
        }, {
            type: 'line',
            name: 'WeChat',
            data: data[dataSeries.CUSTOMER_WITH_WECHAT],
            color: GRAPHS.GLOBAL.COLORS.RANGE7,
            showInLegend: data[dataSeries.CUSTOMER_WITH_WECHAT] ? true : false
        }, {
            type: 'line',
            name: 'Guestbook',
            data: data[dataSeries.CUSTOMER_WITH_GUESTBOOK],
            color: GRAPHS.GLOBAL.COLORS.RANGE6,
            showInLegend: data[dataSeries.CUSTOMER_WITH_GUESTBOOK] ? true : false
        }, {
            type: 'line',
            name: 'RADIUS',
            data: data[dataSeries.CUSTOMER_WITH_RADIUS],
            color: GRAPHS.GLOBAL.COLORS.RANGE11,
            showInLegend: data[dataSeries.CUSTOMER_WITH_RADIUS] ? true : false
        }, {
            type: 'line',
            name: 'SMS',
            data: data[dataSeries.CUSTOMER_WITH_SMS],
            color: GRAPHS.GLOBAL.COLORS.MOJO_PURPLE,
            showInLegend: data[dataSeries.CUSTOMER_WITH_SMS] ? true : false
        }, {
            type: 'line',
            name: 'Web Form',
            data: data[dataSeries.CUSTOMER_WITH_WEBFORM],
            color: GRAPHS.GLOBAL.COLORS.MOJO_DARK_GREY,
            showInLegend: data[dataSeries.CUSTOMER_WITH_WEBFORM] ? true : false
        }, {
            type: 'line',
            name: 'Clickthrough',
            data: data[dataSeries.CUSTOMER_WITH_CLICKTHROUGH],
            color: GRAPHS.GLOBAL.COLORS.MOJO_GREY,
            showInLegend: data[dataSeries.CUSTOMER_WITH_CLICKTHROUGH] ? true : false
        }]
    };

    // making sure legends won't interfere with X-Axis for server-side rendering
    if (isServer) {
        chartTemplateObj.legend.itemStyle = {
            fontSize: '10px'
        };
    }

    chartTemplateObj = _.assign({}, config.defaultSettings, chartTemplateObj);
    return chartTemplateObj;
}
